<script>
  /**
   * Bulma の Field でラップ済みの Input
   */
  import Field from './Field.svelte'
  import { scrollOnFocus } from '../../modules/scrollOnFocus'

  export let type
  export let id
  export let name
  export let label
  export let placeholder
  export let list
  export let autocomplete
  export let isLoading = false
  export let required

  export let value

  const attributes = {}

  if (type) attributes.type = type
  if (placeholder) attributes.placeholder = placeholder
  if (list) attributes.list = list
  if (autocomplete) attributes.autocomplete = autocomplete
</script>

<Field {id} {label} {isLoading}>
  <input
    class="input"
    {id}
    {name}
    {...attributes}
    {required}
    bind:value
    data-testid={`${id}Input`}
    use:scrollOnFocus
  />
  <slot />
</Field>
